import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import {  RiskRatingRoutes   } from "../../../routes/HomeRoutes/RiskRatingRoutes";

export const RiskRatingLayout = () => (
    <SwitchRoute routes={RiskRatingRoutes}/>
);